import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/esnext.json.parse.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-slate-200 shrink-0"
};
const _hoisted_2 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_3 = {
  class: "flex items-center gap-2"
};
const _hoisted_4 = ["disabled"];
const _hoisted_5 = {
  key: 0,
  class: "p-6 flex-1 overflow-y-auto"
};
const _hoisted_6 = {
  class: "space-y-4 animate-pulse"
};
const _hoisted_7 = {
  class: "grid grid-cols-4 gap-4"
};
const _hoisted_8 = {
  key: 1,
  class: "p-6 flex-1 overflow-y-auto"
};
const _hoisted_9 = {
  class: "flex items-start gap-3 mb-6"
};
const _hoisted_10 = {
  class: "flex-1"
};
const _hoisted_11 = {
  class: "text-xl font-semibold text-slate-900"
};
const _hoisted_12 = {
  class: "text-sm text-slate-500 mt-1"
};
const _hoisted_13 = {
  class: "flex flex-col items-end gap-2"
};
const _hoisted_14 = {
  class: "grid grid-cols-4 gap-3 mb-6"
};
const _hoisted_15 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_16 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_17 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_18 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_19 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_20 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_21 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_22 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_23 = {
  key: 0,
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_24 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_25 = {
  key: 1,
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_26 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_27 = {
  key: 2,
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_28 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_29 = {
  class: "mb-6"
};
const _hoisted_30 = {
  class: "flex items-center justify-between mb-2"
};
const _hoisted_31 = {
  class: "flex items-center gap-3"
};
const _hoisted_32 = ["disabled"];
const _hoisted_33 = {
  key: 0,
  class: "w-4 h-4 animate-spin",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_34 = {
  key: 1,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_35 = ["disabled"];
const _hoisted_36 = {
  key: 0,
  class: "w-4 h-4 animate-spin",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_37 = {
  key: 1,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_38 = {
  key: 0,
  class: "bg-slate-50 rounded-lg p-4 text-sm text-slate-600"
};
const _hoisted_39 = {
  key: 0,
  class: "mt-4 rounded-lg border border-slate-200 p-4 mb-6"
};
const _hoisted_40 = {
  key: 0,
  class: "text-xs text-slate-400"
};
const _hoisted_41 = {
  key: 1,
  class: "grid grid-cols-2 gap-3 text-sm"
};
const _hoisted_42 = {
  key: 0
};
const _hoisted_43 = {
  key: 1
};
const _hoisted_44 = {
  key: 2,
  class: "col-span-2"
};
const _hoisted_45 = {
  key: 2,
  class: "text-xs text-slate-400"
};
const _hoisted_46 = {
  key: 1,
  class: "mb-6"
};
const _hoisted_47 = {
  class: "bg-white border border-slate-200 rounded-lg p-4"
};
const _hoisted_48 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_49 = {
  class: "text-xs text-slate-500 mb-1"
};
const _hoisted_50 = {
  key: 0,
  class: "text-sm text-slate-900 font-medium"
};
const _hoisted_51 = {
  key: 1,
  class: "text-sm text-slate-900 font-medium"
};
const _hoisted_52 = {
  key: 2,
  class: "text-sm text-slate-900 whitespace-pre-wrap"
};
const _hoisted_53 = {
  key: 3,
  class: "text-sm text-slate-900 font-medium"
};
const _hoisted_54 = {
  key: 4,
  class: "text-sm text-slate-900 font-medium"
};
const _hoisted_55 = {
  key: 5,
  class: "text-sm text-slate-900 font-medium"
};
const _hoisted_56 = {
  key: 6,
  class: "text-sm"
};
const _hoisted_57 = {
  key: 0,
  class: "text-green-600"
};
const _hoisted_58 = {
  key: 1,
  class: "text-slate-400"
};
const _hoisted_59 = {
  key: 7,
  class: "text-sm text-slate-600"
};
const _hoisted_60 = {
  key: 1,
  class: "text-slate-400"
};
const _hoisted_61 = {
  key: 8,
  class: "text-sm"
};
const _hoisted_62 = {
  class: "overflow-x-auto border border-slate-200 rounded-lg"
};
const _hoisted_63 = {
  class: "w-full text-sm"
};
const _hoisted_64 = {
  class: "bg-slate-50"
};
const _hoisted_65 = {
  class: "px-2 py-1.5 text-xs text-slate-400"
};
const _hoisted_66 = {
  key: 1,
  class: "text-slate-400"
};
const _hoisted_67 = {
  key: 0
};
const _hoisted_68 = ["colspan"];
const _hoisted_69 = {
  key: 0
};
const _hoisted_70 = {
  class: "border-t border-slate-200 bg-slate-50"
};
const _hoisted_71 = {
  key: 9,
  class: "text-sm text-slate-900 font-medium"
};
const _hoisted_72 = {
  key: 0,
  class: "text-center py-4 text-slate-400 text-sm"
};
const _hoisted_73 = {
  class: "mb-6"
};
const _hoisted_74 = {
  class: "flex items-center gap-2 mb-3"
};
const _hoisted_75 = {
  class: "text-xs text-slate-400"
};
const _hoisted_76 = {
  class: "pl-2 space-y-2"
};
const _hoisted_77 = {
  key: 0
};
const _hoisted_78 = {
  key: 1
};
const _hoisted_79 = {
  key: 2
};
const _hoisted_80 = {
  class: "flex-1 min-w-0"
};
const _hoisted_81 = {
  class: "approval-detail-node-header"
};
const _hoisted_82 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_83 = {
  key: 0,
  class: "px-1.5 py-0.5 bg-purple-100 text-purple-600 text-xs rounded"
};
const _hoisted_84 = {
  key: 1,
  class: "px-1.5 py-0.5 bg-green-100 text-green-600 text-xs rounded"
};
const _hoisted_85 = {
  key: 2,
  class: "px-1.5 py-0.5 bg-red-100 text-red-600 text-xs rounded"
};
const _hoisted_86 = {
  key: 3,
  class: "px-1.5 py-0.5 bg-amber-100 text-amber-600 text-xs rounded"
};
const _hoisted_87 = {
  key: 4,
  class: "px-1.5 py-0.5 bg-blue-100 text-blue-600 text-xs rounded"
};
const _hoisted_88 = {
  key: 5,
  class: "approval-detail-mode-tag"
};
const _hoisted_89 = {
  key: 6,
  class: "approval-detail-node-time"
};
const _hoisted_90 = {
  key: 0,
  class: "approval-detail-participants"
};
const _hoisted_91 = ["title"];
const _hoisted_92 = {
  class: "approval-detail-participant-avatar"
};
const _hoisted_93 = {
  key: 0,
  class: "w-full h-full"
};
const _hoisted_94 = ["src"];
const _hoisted_95 = {
  key: 1
};
const _hoisted_96 = ["title"];
const _hoisted_97 = {
  key: 0,
  class: "w-1.5 h-1.5 text-white",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_98 = {
  key: 1,
  class: "w-1.5 h-1.5 text-white",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_99 = {
  key: 2,
  class: "w-1.5 h-1.5 text-white",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_100 = {
  key: 3,
  class: "w-1.5 h-1.5 text-white",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_101 = {
  class: "min-w-0"
};
const _hoisted_102 = {
  class: "approval-detail-participant-main"
};
const _hoisted_103 = {
  class: "approval-detail-participant-name"
};
const _hoisted_104 = {
  key: 0,
  class: "approval-detail-participant-time"
};
const _hoisted_105 = {
  key: 1,
  class: "flex items-center gap-1.5 mt-1.5"
};
const _hoisted_106 = {
  class: "flex items-center gap-1.5 mb-1"
};
const _hoisted_107 = {
  class: "text-xs font-medium text-slate-700"
};
const _hoisted_108 = {
  class: "text-xs text-slate-400"
};
const _hoisted_109 = {
  key: 0,
  class: "text-xs text-green-600"
};
const _hoisted_110 = {
  key: 1,
  class: "text-xs text-red-600"
};
const _hoisted_111 = {
  class: "text-xs text-slate-600"
};
const _hoisted_112 = {
  key: 0,
  class: "absolute left-5 -bottom-3 text-slate-300 z-10"
};
const _hoisted_113 = {
  key: 1,
  class: "text-center py-6 bg-slate-50 rounded-lg text-xs text-slate-400"
};
const _hoisted_114 = {
  key: 2
};
const _hoisted_115 = {
  key: 2,
  class: "p-6 flex-1 overflow-y-auto"
};
const _hoisted_116 = {
  key: 3,
  class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3 shrink-0"
};
import { ref, computed, watch, nextTick, defineAsyncComponent } from 'vue';
import { ElMessage } from 'element-plus';
import { getInstanceDetail, exportApprovalDocx } from '@/api/flow';
import { downloadBlob, resolveBlobErrorMessage } from '@/utils/download';
import { getPlanDetail } from '@/api/plan';
import { getOrderDetail } from '@/api/order';
import { getTraceList } from '@/api/trace';
import { getRefundByApprovalInstanceId } from '@/api/refund';
import { formatDateTimeText } from '@/utils/dateFormat';
import { roundMoney, sumDetailColumn } from '@/utils/workflowDetail';
import AppModal from '@/components/AppModal.vue';
import PlanDetailModal from './PlanDetailModal.vue';
import FileAttachment from './FileAttachment.vue';
export default {
  __name: 'ApprovalDetailModal',
  props: {
    // 控制显示
    modelValue: {
      type: Boolean,
      default: false
    },
    // 标题
    title: {
      type: String,
      default: '审批详情'
    },
    // 实例ID（传入ID会自动加载详情）
    instanceId: {
      type: [String, Number],
      default: null
    },
    // 直接传入详情数据
    detailData: {
      type: Object,
      default: null
    },
    // 类型（用于图标背景色）
    type: {
      type: String,
      default: 'proposal'
    },
    // 优先级
    priority: {
      type: String,
      default: 'normal'
    },
    // 是否显示操作按钮
    showActions: {
      type: Boolean,
      default: false
    },
    // 是否显示审批意见编辑框
    showCommentEditor: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'approve', 'reject', 'close'],
  setup(__props, {
    emit: __emit
  }) {
    const CustomerDetailModal = defineAsyncComponent(() => import('./CustomerDetailModal.vue'));
    const OrderDetailModal = defineAsyncComponent(() => import('./OrderDetailModal.vue'));
    const WealthOperationApplyDetailModal = defineAsyncComponent(() => import('@/views/wealth/components/WealthOperationApplyDetailModal.vue'));
    const props = __props;
    const emit = __emit;
    const loading = ref(false);
    const detail = ref(null);
    const comment = ref('');
    const planDetail = ref(null);
    const planDetailLoading = ref(false);
    const showProposalModal = ref(false);
    const customerDetail = ref(null);
    const showCustomerModal = ref(false);
    const orderDetail = ref(null);
    const orderTraceList = ref([]);
    const orderDetailLoading = ref(false);
    const showOrderModal = ref(false);
    const showWealthModal = ref(false);
    const exportingDocx = ref(false);

    // 导出审批单据 Word（exportable 由后端组装：实例 APPROVED 且模板已配置导出布局）
    async function handleExportDocx() {
      const instanceId = props.instanceId || detail.value?.instance?.id;
      if (!instanceId || exportingDocx.value) return;
      exportingDocx.value = true;
      try {
        const {
          blob,
          fileName
        } = await exportApprovalDocx(instanceId);
        downloadBlob(blob, fileName);
        ElMessage.success('导出成功');
      } catch (error) {
        ElMessage.error(await resolveBlobErrorMessage(error));
      } finally {
        exportingDocx.value = false;
      }
    }

    // 类型背景色映射
    const typeBgMap = {
      'proposal': 'bg-blue-100 text-blue-600',
      'customer': 'bg-emerald-100 text-emerald-600',
      'order': 'bg-amber-100 text-amber-600',
      'wealth': 'bg-cyan-100 text-cyan-700',
      'franchisee': 'bg-purple-100 text-purple-600',
      'product': 'bg-green-100 text-green-600',
      'refund': 'bg-amber-100 text-amber-600'
    };
    const typeBgClass = computed(() => typeBgMap[props.type] || 'bg-slate-100 text-slate-600');

    // 优先级样式映射
    const priorityMap = {
      'urgent': {
        text: '紧急',
        class: 'bg-red-100 text-red-700'
      },
      'high': {
        text: '高',
        class: 'bg-amber-100 text-amber-700'
      },
      'normal': {
        text: '普通',
        class: 'bg-slate-100 text-slate-600'
      }
    };
    const priorityText = computed(() => priorityMap[props.priority]?.text || '普通');
    const priorityClass = computed(() => priorityMap[props.priority]?.class || 'bg-slate-100 text-slate-600');

    // 状态样式
    const statusClass = computed(() => {
      if (!detail.value?.instance?.status) return 'bg-slate-100 text-slate-700';
      const status = detail.value.instance.status;
      if (status === 'APPROVED') return 'bg-green-100 text-green-700';
      if (status === 'REJECTED') return 'bg-red-100 text-red-700';
      return 'bg-blue-100 text-blue-700';
    });

    // 解析表单 schema
    const formSchemaFields = computed(() => {
      if (!detail.value?.template?.formSchema) return [];
      try {
        const schema = typeof detail.value.template.formSchema === 'string' ? JSON.parse(detail.value.template.formSchema) : detail.value.template.formSchema;
        const fields = schema.fields || schema;
        return Array.isArray(fields) ? fields : [];
      } catch {
        console.error('解析表单 schema 失败');
        return [];
      }
    });

    // 是否为方案审批流程
    const isPlanApprovalFlow = computed(() => {
      return detail.value?.template?.templateCode === 'PLAN_APPROVAL_FLOW';
    });
    const isCustomerApprovalFlow = computed(() => {
      return props.type === 'customer' || detail.value?.template?.templateCode === 'CUSTOMER_REFERRER_CHANGE_FLOW' || detail.value?.instance?.bizType === 'customer_referrer_change_approval';
    });
    const isOrderApprovalFlow = computed(() => {
      return props.type === 'order' || detail.value?.template?.templateCode === 'ORDER_AMOUNT_CHANGE_FLOW' || detail.value?.template?.templateCode === 'ORDER_ADD_APPROVAL_FLOW' || detail.value?.instance?.bizType === 'order_amount_change_approval' || detail.value?.instance?.bizType === 'order_add_approval';
    });
    const isWealthApprovalFlow = computed(() => {
      return props.type === 'wealth' || detail.value?.template?.templateCode === 'WEALTH_FUND_OPERATION_FLOW' || detail.value?.instance?.bizType === 'wealth_fund_operation_approval';
    });
    const wealthApplyId = computed(() => {
      return detail.value?.formData?.applyId || detail.value?.instance?.bizId || detail.value?.formData?.bizId || null;
    });
    const wealthApprovalInstanceId = computed(() => {
      return props.instanceId || detail.value?.instance?.id || detail.value?.instance?.instanceId || null;
    });

    // 是否为退款审批流程
    const isRefundApprovalFlow = computed(() => {
      return props.type === 'refund' || detail.value?.template?.templateCode === 'REFUND_FLOW' || detail.value?.instance?.bizType === 'refund';
    });
    const refundApprovalInstanceId = computed(() => {
      return props.instanceId || detail.value?.instance?.id || detail.value?.instance?.instanceId || null;
    });
    const refundApply = ref(null);
    const refundLoading = ref(false);
    const refundApplyStatusMap = {
      SUBMITTING: '提交中',
      APPROVING: '审批中',
      REFUNDING: '退款中',
      REFUNDED: '已退款',
      REJECTED: '已驳回',
      CANCELLED: '已撤销',
      REFUND_FAILED: '退款失败'
    };
    const refundApplyStatusText = status => refundApplyStatusMap[status] || status || '-';
    const loadRefundApply = async () => {
      if (!isRefundApprovalFlow.value || !refundApprovalInstanceId.value) return;
      refundLoading.value = true;
      try {
        refundApply.value = await getRefundByApprovalInstanceId(refundApprovalInstanceId.value);
      } catch (error) {
        refundApply.value = null;
      } finally {
        refundLoading.value = false;
      }
    };
    watch([isRefundApprovalFlow, refundApprovalInstanceId], loadRefundApply, {
      immediate: true
    });

    // 格式化选择值
    function formatSelectValue(value, options) {
      if (value === undefined || value === null) return '-';
      if (Array.isArray(value)) {
        if (!value.length) return '-';
        const labels = value.map(v => {
          const opt = options?.find(o => o.value == v || o.value === v);
          return opt?.label || v;
        });
        return labels.join('、');
      }
      const opt = options?.find(o => o.value == value || o.value === value);
      return opt?.label || value || '-';
    }
    function getFormFileList(fieldKey) {
      const value = detail.value?.formData?.[fieldKey];
      if (!value) return [];
      return Array.isArray(value) ? value : [value];
    }

    // 明细表行数据（只读回显）
    function getDetailRows(fieldKey) {
      const value = detail.value?.formData?.[fieldKey];
      return Array.isArray(value) ? value : [];
    }

    // 行内附件列表
    function getDetailRowFiles(row, childKey) {
      const value = row?.[childKey];
      if (!value) return [];
      return Array.isArray(value) ? value : [value];
    }

    // 某列对应的合计配置
    function getDetailSummaryTarget(field, columnKey) {
      return (field.summary || []).find(s => s.column === columnKey) || null;
    }

    // 合计值：优先取 formData 中已存的 targetKey，缺失时按行数据兜底求和
    // 兜底仅为展示口径，非校验口径（后端以提交时 BigDecimal 重算为准）
    function getDetailSummaryValue(field, columnKey) {
      const sum = getDetailSummaryTarget(field, columnKey);
      if (!sum) return 0;
      const stored = detail.value?.formData?.[sum.targetKey];
      if (stored !== undefined && stored !== null) return stored;
      const total = sumDetailColumn(getDetailRows(field.key), columnKey);
      const column = (field.children || []).find(c => c.key === columnKey);
      return column?.type === 'MONEY' ? roundMoney(total) : total;
    }
    function formatDetailCellNumber(value, digits) {
      const num = Number(value);
      if (!Number.isFinite(num)) return '-';
      return Number.isInteger(digits) ? num.toLocaleString('zh-CN', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
      }) : num.toLocaleString();
    }
    const APPROVED_ACTION_TYPES = ['AGREE', 'AUTO_AGREE', 'COMPLETED'];
    const FINISHED_APPROVAL_ACTION_TYPES = [...APPROVED_ACTION_TYPES, 'REJECT'];

    // 审批动作类型样式
    function getActionTypeStyle(actionType) {
      const map = {
        'AGREE': {
          bgClass: 'bg-green-500',
          textClass: 'text-green-700',
          text: '已同意'
        },
        'AUTO_AGREE': {
          bgClass: 'bg-green-500',
          textClass: 'text-green-700',
          text: '自动通过'
        },
        'COMPLETED': {
          bgClass: 'bg-green-500',
          textClass: 'text-green-700',
          text: '已完成'
        },
        'READ': {
          bgClass: 'bg-green-500',
          textClass: 'text-green-700',
          text: '已读'
        },
        'REJECT': {
          bgClass: 'bg-red-500',
          textClass: 'text-red-700',
          text: '已驳回'
        },
        'CANCEL': {
          bgClass: 'bg-slate-400',
          textClass: 'text-slate-500',
          text: '已取消'
        },
        'CANCELLED': {
          bgClass: 'bg-slate-400',
          textClass: 'text-slate-500',
          text: '已取消'
        },
        'EXPIRED': {
          bgClass: 'bg-amber-500',
          textClass: 'text-amber-700',
          text: '已过期'
        },
        'DELEGATE': {
          bgClass: 'bg-blue-500',
          textClass: 'text-blue-700',
          text: '已转交'
        },
        'PENDING': {
          bgClass: 'bg-amber-400',
          textClass: 'text-amber-700',
          text: '待审批'
        }
      };
      return map[actionType] || {
        bgClass: 'bg-slate-300',
        textClass: 'text-slate-500',
        text: actionType
      };
    }
    function getApprovalModeBadgeText(node) {
      if (node?.nodeType !== 'APPROVAL') return '';
      if (!node?.approvers?.length || node?.approvers?.length <= 1) return '';
      if (node.approvalMode === 'ALL') return '会签';
      if (node.approvalMode === 'ANY') return '或签';
      return '';
    }
    function getNodeApprovedTime(node) {
      if (node?.nodeType !== 'APPROVAL' || node?.status !== 'APPROVED') return '';
      const latestTime = (node.approvers || []).filter(approver => APPROVED_ACTION_TYPES.includes(approver?.actionType) && approver?.actionTime).map(approver => new Date(approver.actionTime).getTime()).filter(time => Number.isFinite(time)).reduce((latest, time) => Math.max(latest, time), 0);
      return latestTime ? formatDateTime(latestTime) : '';
    }
    function getApproverStatusText(approver, node) {
      if (!approver?.actionType) return '';
      if (node?.nodeType === 'CC' && approver.actionType === 'PENDING') return '未读';
      return approver.actionTypeDesc || getActionTypeStyle(approver.actionType).text;
    }
    function getApproverActionTimeText(approver, node) {
      if (!approver?.actionTime) return '';
      if (node?.nodeType === 'CC') {
        return approver.actionType === 'READ' ? formatDateTime(approver.actionTime) : '';
      }
      if (!FINISHED_APPROVAL_ACTION_TYPES.includes(approver.actionType)) return '';
      return formatDateTime(approver.actionTime);
    }
    function isApprovalActive() {
      return detail.value?.instance?.status === 'APPROVING';
    }
    function getCurrentPendingNode() {
      if (!isApprovalActive()) return null;
      return (detail.value?.flowNodes || []).find(node => node?.status === 'PENDING') || null;
    }
    function getCurrentNodeDisplayName() {
      if (!isApprovalActive()) return '';
      return detail.value?.instance?.currentNodeName || getCurrentPendingNode()?.nodeName || '';
    }
    function getTotalWaitingDuration() {
      if (!isApprovalActive()) return '';
      return formatDurationBetween(detail.value?.instance?.createTime);
    }
    function getTotalElapsedDuration() {
      const instance = detail.value?.instance;
      if (isApprovalActive() || !instance?.createTime || !instance?.endTime) return '';
      return formatDurationBetween(instance.createTime, instance.endTime);
    }
    function getCurrentNodeWaitingDuration() {
      if (!isApprovalActive()) return '';
      const node = getCurrentPendingNode();
      if (!node?.startTime) return '';
      return formatDurationBetween(node.startTime);
    }
    function formatDurationBetween(start, end = Date.now()) {
      if (!start) return '';
      const startTime = new Date(start).getTime();
      const endTime = typeof end === 'number' ? end : new Date(end).getTime();
      if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || endTime < startTime) {
        return '';
      }
      const totalMinutes = Math.floor((endTime - startTime) / 60000);
      const days = Math.floor(totalMinutes / 1440);
      const hours = Math.floor(totalMinutes % 1440 / 60);
      const minutes = totalMinutes % 60;
      if (days > 0) {
        return `${days}天${hours}小时`;
      }
      if (hours > 0) {
        return `${hours}小时${minutes}分钟`;
      }
      return `${Math.max(minutes, 1)}分钟`;
    }

    // 格式化时间
    function formatDateTime(date) {
      if (!date) return '-';
      return new Date(date).toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    }

    // 加载详情
    async function loadDetail() {
      resetBusinessDetailModals();
      if (props.detailData) {
        detail.value = props.detailData;
        return;
      }
      if (!props.instanceId) {
        detail.value = null;
        return;
      }
      loading.value = true;
      try {
        const res = await getInstanceDetail(props.instanceId);
        detail.value = res || null;
      } catch (error) {
        console.error('加载实例详情失败:', error);
        detail.value = null;
      } finally {
        loading.value = false;
      }
    }

    // 加载方案详情
    async function loadPlanDetail() {
      const planId = detail.value?.formData?.planId;
      if (!planId) return;
      planDetailLoading.value = true;
      try {
        const res = await getPlanDetail(planId);
        planDetail.value = res || null;
        // 先设置数据，再显示弹窗，确保 PlanDetailModal 能获取到
        await nextTick();
        showProposalModal.value = true;
      } catch (error) {
        console.error('加载方案详情失败:', error);
      } finally {
        planDetailLoading.value = false;
      }
    }
    async function loadCustomerDetail() {
      const customerId = detail.value?.formData?.customerId;
      if (!customerId) return;
      customerDetail.value = {
        id: customerId
      };
      await nextTick();
      showCustomerModal.value = true;
    }
    async function loadOrderDetail() {
      const orderId = detail.value?.formData?.orderId || detail.value?.instance?.bizId;
      if (!orderId) return;
      orderDetailLoading.value = true;
      try {
        orderDetail.value = await getOrderDetail(orderId);
        orderTraceList.value = await getTraceList('ORDER', orderId);
        await nextTick();
        showOrderModal.value = true;
      } catch (error) {
        console.error('加载订单详情失败:', error);
      } finally {
        orderDetailLoading.value = false;
      }
    }

    // 关闭弹窗
    function closeModal() {
      resetBusinessDetailModals();
      emit('update:modelValue', false);
      emit('close');
    }
    function resetBusinessDetailModals() {
      showProposalModal.value = false;
      showCustomerModal.value = false;
      showOrderModal.value = false;
      showWealthModal.value = false;
    }

    // 通过审批
    function handleApprove() {
      emit('approve', {
        comment: comment.value,
        detail: detail.value
      });
    }

    // 驳回审批
    function handleReject() {
      emit('reject', {
        comment: comment.value,
        detail: detail.value
      });
    }

    // 监听弹窗显示
    watch(() => props.modelValue, val => {
      if (val) {
        comment.value = '';
        loadDetail();
      }
    }, {
      immediate: true
    });

    // 监听详情数据变化
    watch(() => props.detailData, val => {
      if (val) {
        detail.value = val;
      }
    });

    // 监听instanceId变化
    watch(() => props.instanceId, () => {
      if (props.modelValue && props.instanceId) {
        loadDetail();
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: __props.modelValue,
        size: "4xl",
        onClose: closeModal
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, _toDisplayString(__props.title), 1), _createElementVNode("div", _hoisted_3, [detail.value?.template?.exportable === true ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "px-3 py-1.5 text-sm text-primary-600 border border-primary-200 rounded-lg hover:bg-primary-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1",
          disabled: exportingDocx.value,
          onClick: handleExportDocx
        }, [_cache[6] || (_cache[6] = _createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 15V3"
        })], -1)), _createTextVNode(" " + _toDisplayString(exportingDocx.value ? '导出中...' : '导出 Word'), 1)], 8, _hoisted_4)) : _createCommentVNode("", true), _createElementVNode("button", {
          onClick: closeModal,
          class: "p-1.5 text-slate-400 hover:text-slate-600"
        }, [...(_cache[7] || (_cache[7] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])])]), loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_cache[8] || (_cache[8] = _createElementVNode("div", {
          class: "flex items-center gap-3 mb-4"
        }, [_createElementVNode("div", {
          class: "w-12 h-12 bg-slate-200 rounded-lg"
        }), _createElementVNode("div", {
          class: "flex-1"
        }, [_createElementVNode("div", {
          class: "h-5 w-48 bg-slate-200 rounded mb-2"
        }), _createElementVNode("div", {
          class: "h-4 w-32 bg-slate-200 rounded"
        })])], -1)), _createElementVNode("div", _hoisted_7, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, n => {
          return _createElementVNode("div", {
            key: n,
            class: "h-20 bg-slate-200 rounded-lg"
          });
        }), 64))]), _cache[9] || (_cache[9] = _createElementVNode("div", {
          class: "h-32 bg-slate-200 rounded-lg"
        }, null, -1))])])) : detail.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
          class: _normalizeClass(['w-12 h-12 rounded-lg flex items-center justify-center', typeBgClass.value])
        }, [...(_cache[10] || (_cache[10] = [_createElementVNode("svg", {
          class: "w-6 h-6",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        })], -1)]))], 2), _createElementVNode("div", _hoisted_10, [_createElementVNode("h4", _hoisted_11, _toDisplayString(detail.value.instance?.title), 1), _createElementVNode("p", _hoisted_12, _toDisplayString(detail.value.instance?.applicantName) + " | " + _toDisplayString(detail.value.template?.templateName), 1)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("span", {
          class: _normalizeClass(['px-3 py-1 rounded-full text-sm font-medium', priorityClass.value])
        }, _toDisplayString(detail.value.instance?.priorityDesc || priorityText.value), 3), _createElementVNode("span", {
          class: _normalizeClass(['px-2 py-0.5 rounded text-xs', statusClass.value])
        }, _toDisplayString(detail.value.instance?.statusDesc), 3)])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_cache[11] || (_cache[11] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "实例编号", -1)), _createElementVNode("div", _hoisted_16, _toDisplayString(detail.value.instance?.instanceNo || '-'), 1)]), _createElementVNode("div", _hoisted_17, [_cache[12] || (_cache[12] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "当前节点", -1)), _createElementVNode("div", _hoisted_18, _toDisplayString(getCurrentNodeDisplayName() || '-'), 1)]), _createElementVNode("div", _hoisted_19, [_cache[13] || (_cache[13] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "申请时间", -1)), _createElementVNode("div", _hoisted_20, _toDisplayString(formatDateTime(detail.value.instance?.createTime)), 1)]), _createElementVNode("div", _hoisted_21, [_cache[14] || (_cache[14] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "结束时间", -1)), _createElementVNode("div", _hoisted_22, _toDisplayString(formatDateTime(detail.value.instance?.endTime) || '-'), 1)]), isApprovalActive() ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_cache[15] || (_cache[15] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "总等待", -1)), _createElementVNode("div", _hoisted_24, _toDisplayString(getTotalWaitingDuration() || '-'), 1)])) : getTotalElapsedDuration() ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_cache[16] || (_cache[16] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "总计用时", -1)), _createElementVNode("div", _hoisted_26, _toDisplayString(getTotalElapsedDuration()), 1)])) : _createCommentVNode("", true), isApprovalActive() ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_cache[17] || (_cache[17] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "当前节点等待", -1)), _createElementVNode("div", _hoisted_28, _toDisplayString(getCurrentNodeWaitingDuration() || '-'), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_cache[26] || (_cache[26] = _createElementVNode("h5", {
          class: "text-sm font-medium text-slate-700"
        }, "申请说明", -1)), _createElementVNode("div", _hoisted_31, [isPlanApprovalFlow.value && detail.value.formData?.planId ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          disabled: planDetailLoading.value,
          class: "text-sm text-primary-600 hover:text-primary-700 flex items-center gap-1",
          onClick: loadPlanDetail
        }, [planDetailLoading.value ? (_openBlock(), _createElementBlock("svg", _hoisted_33, [...(_cache[18] || (_cache[18] = [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
        }, null, -1)]))])) : (_openBlock(), _createElementBlock("svg", _hoisted_34, [...(_cache[19] || (_cache[19] = [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        }, null, -1)]))])), _cache[20] || (_cache[20] = _createTextVNode(" 查看方案详情 ", -1))], 8, _hoisted_32)) : _createCommentVNode("", true), isCustomerApprovalFlow.value && detail.value.formData?.customerId ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "text-sm text-primary-600 hover:text-primary-700 flex items-center gap-1",
          onClick: loadCustomerDetail
        }, [...(_cache[21] || (_cache[21] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M5.121 17.804A7.97 7.97 0 0112 14a7.97 7.97 0 016.879 3.804M15 10a3 3 0 11-6 0 3 3 0 016 0z"
        })], -1), _createTextVNode(" 查看客户详情 ", -1)]))])) : _createCommentVNode("", true), isOrderApprovalFlow.value && (detail.value.formData?.orderId || detail.value.instance?.bizId) ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          disabled: orderDetailLoading.value,
          class: "text-sm text-primary-600 hover:text-primary-700 flex items-center gap-1",
          onClick: loadOrderDetail
        }, [orderDetailLoading.value ? (_openBlock(), _createElementBlock("svg", _hoisted_36, [...(_cache[22] || (_cache[22] = [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
        }, null, -1)]))])) : (_openBlock(), _createElementBlock("svg", _hoisted_37, [...(_cache[23] || (_cache[23] = [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 14h6m-6-4h6m-7 8h8a2 2 0 002-2V8.414a1 1 0 00-.293-.707l-3.414-3.414A1 1 0 0013.586 4H8a2 2 0 00-2 2v10a2 2 0 002 2z"
        }, null, -1)]))])), _cache[24] || (_cache[24] = _createTextVNode(" 查看订单详情 ", -1))], 8, _hoisted_35)) : _createCommentVNode("", true), isWealthApprovalFlow.value && wealthApprovalInstanceId.value ? (_openBlock(), _createElementBlock("button", {
          key: 3,
          class: "text-sm text-primary-600 hover:text-primary-700 flex items-center gap-1",
          onClick: _cache[0] || (_cache[0] = $event => showWealthModal.value = true)
        }, [...(_cache[25] || (_cache[25] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        })], -1), _createTextVNode(" 查看资金申请详情 ", -1)]))])) : _createCommentVNode("", true)])]), detail.value.instance?.description ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(detail.value.instance?.description), 1)) : _createCommentVNode("", true)]), isRefundApprovalFlow.value ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_cache[34] || (_cache[34] = _createElementVNode("div", {
          class: "text-sm font-medium text-slate-700 mb-3"
        }, "退款申请信息", -1)), refundLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_40, "加载中...")) : refundApply.value ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_createElementVNode("div", null, [_cache[27] || (_cache[27] = _createElementVNode("span", {
          class: "text-slate-400"
        }, "申请单号：", -1)), _createTextVNode(_toDisplayString(refundApply.value.applyNo), 1)]), _createElementVNode("div", null, [_cache[28] || (_cache[28] = _createElementVNode("span", {
          class: "text-slate-400"
        }, "退款金额：", -1)), _createTextVNode(_toDisplayString(refundApply.value.refundAmount) + " 元", 1)]), _createElementVNode("div", null, [_cache[29] || (_cache[29] = _createElementVNode("span", {
          class: "text-slate-400"
        }, "退款原因：", -1)), _createTextVNode(_toDisplayString(refundApply.value.refundReason || '-'), 1)]), _createElementVNode("div", null, [_cache[30] || (_cache[30] = _createElementVNode("span", {
          class: "text-slate-400"
        }, "申请状态：", -1)), _createTextVNode(_toDisplayString(refundApplyStatusText(refundApply.value.status)), 1)]), refundApply.value.latestRefundOrder ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_cache[31] || (_cache[31] = _createElementVNode("span", {
          class: "text-slate-400"
        }, "退款单号：", -1)), _createTextVNode(_toDisplayString(refundApply.value.latestRefundOrder.outRefundNo), 1)])) : _createCommentVNode("", true), refundApply.value.latestRefundOrder ? (_openBlock(), _createElementBlock("div", _hoisted_43, [_cache[32] || (_cache[32] = _createElementVNode("span", {
          class: "text-slate-400"
        }, "渠道状态：", -1)), _createTextVNode(_toDisplayString(refundApply.value.latestRefundOrder.tradeState || '-'), 1)])) : _createCommentVNode("", true), refundApply.value.refundFailedReason ? (_openBlock(), _createElementBlock("div", _hoisted_44, [_cache[33] || (_cache[33] = _createElementVNode("span", {
          class: "text-slate-400"
        }, "失败原因：", -1)), _createTextVNode(_toDisplayString(refundApply.value.refundFailedReason), 1)])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_45, "未查询到退款申请数据"))])) : _createCommentVNode("", true), detail.value.formData && detail.value.template?.formSchema && formSchemaFields.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_cache[37] || (_cache[37] = _createElementVNode("h5", {
          class: "text-sm font-medium text-slate-700 mb-3"
        }, "申请内容", -1)), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formSchemaFields.value, field => {
          return _openBlock(), _createElementBlock("div", {
            key: field.key,
            class: _normalizeClass(['flex flex-col', ['TEXTAREA', 'DETAIL'].includes(field.type) ? 'col-span-2' : ''])
          }, [_createElementVNode("label", _hoisted_49, _toDisplayString(field.label), 1), ['TEXT', 'EMAIL', 'PHONE', 'URL'].includes(field.type) ? (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(detail.value.formData[field.key] || '-'), 1)) : ['NUMBER', 'MONEY'].includes(field.type) ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(detail.value.formData[field.key] != null ? (field.type === 'MONEY' ? '¥' : '') + (typeof detail.value.formData[field.key] === 'number' ? detail.value.formData[field.key].toLocaleString() : detail.value.formData[field.key]) : '-'), 1)) : field.type === 'TEXTAREA' ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(detail.value.formData[field.key] || '-'), 1)) : field.type === 'DATE' ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(detail.value.formData[field.key] || '-'), 1)) : field.type === 'DATETIME' ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(detail.value.formData[field.key] || '-'), 1)) : ['SELECT', 'RADIO', 'CHECKBOX'].includes(field.type) ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(formatSelectValue(detail.value.formData[field.key], field.options)), 1)) : field.type === 'SWITCH' ? (_openBlock(), _createElementBlock("div", _hoisted_56, [detail.value.formData[field.key] ? (_openBlock(), _createElementBlock("span", _hoisted_57, "是")) : (_openBlock(), _createElementBlock("span", _hoisted_58, "否"))])) : field.type === 'FILE' ? (_openBlock(), _createElementBlock("div", _hoisted_59, [getFormFileList(field.key).length ? (_openBlock(), _createBlock(FileAttachment, {
            key: 0,
            files: getFormFileList(field.key)
          }, null, 8, ["files"])) : (_openBlock(), _createElementBlock("span", _hoisted_60, "-"))])) : field.type === 'DETAIL' ? (_openBlock(), _createElementBlock("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, [_createElementVNode("table", _hoisted_63, [_createElementVNode("thead", null, [_createElementVNode("tr", _hoisted_64, [_cache[35] || (_cache[35] = _createElementVNode("th", {
            class: "px-2 py-1.5 text-left text-xs text-slate-500 w-8"
          }, "#", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.children || [], child => {
            return _openBlock(), _createElementBlock("th", {
              key: child.key,
              class: "px-2 py-1.5 text-left text-xs font-medium text-slate-600 whitespace-nowrap"
            }, _toDisplayString(child.label), 1);
          }), 128))])]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDetailRows(field.key), (row, rowIndex) => {
            return _openBlock(), _createElementBlock("tr", {
              key: rowIndex,
              class: "border-t border-slate-100"
            }, [_createElementVNode("td", _hoisted_65, _toDisplayString(rowIndex + 1), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.children || [], child => {
              return _openBlock(), _createElementBlock("td", {
                key: child.key,
                class: "px-2 py-1.5 text-slate-800"
              }, [['SELECT', 'RADIO', 'CHECKBOX'].includes(child.type) ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 0
              }, [_createTextVNode(_toDisplayString(formatSelectValue(row[child.key], child.options)), 1)], 64)) : child.type === 'FILE' ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 1
              }, [getDetailRowFiles(row, child.key).length ? (_openBlock(), _createBlock(FileAttachment, {
                key: 0,
                files: getDetailRowFiles(row, child.key)
              }, null, 8, ["files"])) : (_openBlock(), _createElementBlock("span", _hoisted_66, "-"))], 64)) : child.type === 'MONEY' ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 2
              }, [_createTextVNode(_toDisplayString(row[child.key] != null && row[child.key] !== '' ? '¥' + formatDetailCellNumber(row[child.key], 2) : '-'), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
                key: 3
              }, [_createTextVNode(_toDisplayString(row[child.key] != null && row[child.key] !== '' ? row[child.key] : '-'), 1)], 64))]);
            }), 128))]);
          }), 128)), !getDetailRows(field.key).length ? (_openBlock(), _createElementBlock("tr", _hoisted_67, [_createElementVNode("td", {
            colspan: (field.children || []).length + 1,
            class: "px-2 py-3 text-center text-slate-400 text-xs"
          }, "暂无明细数据", 8, _hoisted_68)])) : _createCommentVNode("", true)]), (field.summary || []).length ? (_openBlock(), _createElementBlock("tfoot", _hoisted_69, [_createElementVNode("tr", _hoisted_70, [_cache[36] || (_cache[36] = _createElementVNode("td", {
            class: "px-2 py-1.5 text-xs text-slate-500"
          }, "合计", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.children || [], child => {
            return _openBlock(), _createElementBlock("td", {
              key: child.key,
              class: "px-2 py-1.5 font-medium text-slate-700"
            }, [getDetailSummaryTarget(field, child.key) ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createTextVNode(_toDisplayString(getDetailSummaryValue(field, child.key) !== '' ? (child.type === 'MONEY' ? '¥' : '') + formatDetailCellNumber(getDetailSummaryValue(field, child.key), child.type === 'MONEY' ? 2 : undefined) : '-'), 1)], 64)) : _createCommentVNode("", true)]);
          }), 128))])])) : _createCommentVNode("", true)])])])) : (_openBlock(), _createElementBlock("div", _hoisted_71, _toDisplayString(detail.value.formData[field.key] || '-'), 1))], 2);
        }), 128))]), !formSchemaFields.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_72, " 暂无表单数据 ")) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_73, [_createElementVNode("div", _hoisted_74, [_cache[38] || (_cache[38] = _createElementVNode("svg", {
          class: "w-4 h-4 text-primary-500",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        })], -1)), _cache[39] || (_cache[39] = _createElementVNode("span", {
          class: "text-sm font-medium text-slate-700"
        }, "审批流程", -1)), _createElementVNode("span", _hoisted_75, "(" + _toDisplayString(detail.value.flowNodes?.length || 0) + "个节点)", 1)]), _createElementVNode("div", _hoisted_76, [detail.value.flowNodes?.length ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(detail.value.flowNodes, (node, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: node.nodeId,
            class: "relative"
          }, [_createElementVNode("div", {
            class: _normalizeClass(["flex items-start gap-3 p-3 bg-white border border-slate-200 rounded-lg", [node.status === 'APPROVED' ? 'border-green-200' : '', node.status === 'REJECTED' ? 'border-red-200' : '', node.status === 'PENDING' ? 'border-amber-200' : '']])
          }, [_createElementVNode("div", {
            class: _normalizeClass(['w-8 h-8 rounded-full flex items-center justify-center shrink-0 text-sm font-medium mt-0.5', node.nodeType === 'CC' ? 'bg-purple-100 text-purple-600' : node.nodeType === 'START' ? 'bg-green-100 text-green-600' : node.nodeType === 'END' ? 'bg-slate-100 text-slate-600' : node.status === 'APPROVED' ? 'bg-green-100 text-green-600' : node.status === 'REJECTED' ? 'bg-red-100 text-red-600' : 'bg-blue-100 text-blue-600'])
          }, [node.nodeType === 'START' ? (_openBlock(), _createElementBlock("span", _hoisted_77, [...(_cache[40] || (_cache[40] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1)]))])) : node.nodeType === 'END' ? (_openBlock(), _createElementBlock("span", _hoisted_78, [...(_cache[41] || (_cache[41] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])) : (_openBlock(), _createElementBlock("span", _hoisted_79, _toDisplayString(index + 1), 1))], 2), _createElementVNode("div", _hoisted_80, [_createElementVNode("div", _hoisted_81, [_createElementVNode("span", _hoisted_82, _toDisplayString(node.nodeName), 1), node.nodeType === 'CC' ? (_openBlock(), _createElementBlock("span", _hoisted_83, "抄送")) : node.status === 'APPROVED' ? (_openBlock(), _createElementBlock("span", _hoisted_84, "已通过")) : node.status === 'REJECTED' ? (_openBlock(), _createElementBlock("span", _hoisted_85, "已驳回")) : node.status === 'PENDING' ? (_openBlock(), _createElementBlock("span", _hoisted_86, "待审批")) : node.nodeType !== 'START' && node.nodeType !== 'END' ? (_openBlock(), _createElementBlock("span", _hoisted_87, "审批")) : _createCommentVNode("", true), getApprovalModeBadgeText(node) ? (_openBlock(), _createElementBlock("span", _hoisted_88, _toDisplayString(getApprovalModeBadgeText(node)), 1)) : _createCommentVNode("", true), getNodeApprovedTime(node) ? (_openBlock(), _createElementBlock("span", _hoisted_89, _toDisplayString(getNodeApprovedTime(node)), 1)) : _createCommentVNode("", true)]), node.approvers?.length ? (_openBlock(), _createElementBlock("div", _hoisted_90, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(node.approvers, (approver, idx) => {
            return _openBlock(), _createElementBlock("div", {
              key: approver.userId || idx,
              class: "approval-detail-participant"
            }, [_createElementVNode("div", {
              class: "relative",
              title: approver.userName
            }, [_createElementVNode("div", _hoisted_92, [approver.avatar ? (_openBlock(), _createElementBlock("span", _hoisted_93, [_createElementVNode("img", {
              src: approver.avatar,
              class: "w-full h-full object-cover",
              alt: ""
            }, null, 8, _hoisted_94)])) : (_openBlock(), _createElementBlock("span", _hoisted_95, _toDisplayString(approver.userName?.charAt(0) || 'U'), 1))]), approver.actionType ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(['absolute -top-0.5 -left-0.5 w-2.5 h-2.5 rounded-full flex items-center justify-center ring-1 ring-white', getActionTypeStyle(approver.actionType).bgClass]),
              title: getActionTypeStyle(approver.actionType).text
            }, [['AGREE', 'AUTO_AGREE', 'COMPLETED', 'READ'].includes(approver.actionType) ? (_openBlock(), _createElementBlock("svg", _hoisted_97, [...(_cache[42] || (_cache[42] = [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "3",
              d: "M5 13l4 4L19 7"
            }, null, -1)]))])) : ['REJECT', 'CANCEL', 'CANCELLED', 'EXPIRED'].includes(approver.actionType) ? (_openBlock(), _createElementBlock("svg", _hoisted_98, [...(_cache[43] || (_cache[43] = [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "3",
              d: "M6 18L18 6M6 6l12 12"
            }, null, -1)]))])) : ['DELEGATE'].includes(approver.actionType) ? (_openBlock(), _createElementBlock("svg", _hoisted_99, [...(_cache[44] || (_cache[44] = [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
            }, null, -1)]))])) : ['PENDING'].includes(approver.actionType) ? (_openBlock(), _createElementBlock("svg", _hoisted_100, [...(_cache[45] || (_cache[45] = [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            }, null, -1)]))])) : _createCommentVNode("", true)], 10, _hoisted_96)) : _createCommentVNode("", true)], 8, _hoisted_91), _createElementVNode("div", _hoisted_101, [_createElementVNode("div", _hoisted_102, [_createElementVNode("span", _hoisted_103, _toDisplayString(approver.userName), 1), getApproverStatusText(approver, node) ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["approval-detail-participant-status", getActionTypeStyle(approver.actionType).textClass])
            }, _toDisplayString(getApproverStatusText(approver, node)), 3)) : _createCommentVNode("", true)]), getApproverActionTimeText(approver, node) ? (_openBlock(), _createElementBlock("div", _hoisted_104, _toDisplayString(getApproverActionTimeText(approver, node)), 1)) : _createCommentVNode("", true)])]);
          }), 128))])) : node.nodeType !== 'START' && node.nodeType !== 'END' ? (_openBlock(), _createElementBlock("div", _hoisted_105, [...(_cache[46] || (_cache[46] = [_createElementVNode("div", {
            class: "w-6 h-6 rounded-full bg-slate-100 border-2 border-white flex items-center justify-center"
          }, [_createElementVNode("svg", {
            class: "w-3 h-3 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          })])], -1), _createElementVNode("span", {
            class: "text-xs text-slate-400"
          }, "系统匹配", -1)]))])) : _createCommentVNode("", true), node.approvers?.length ? (_openBlock(true), _createElementBlock(_Fragment, {
            key: 2
          }, _renderList(node.approvers, (approver, idx) => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: approver.userId || idx
            }, [approver.remark ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["mt-2 p-2 bg-slate-50 rounded border-l-2", approver.action === 'REJECTED' ? 'border-red-400' : approver.action === 'APPROVED' ? 'border-green-400' : 'border-slate-300'])
            }, [_createElementVNode("div", _hoisted_106, [_createElementVNode("span", _hoisted_107, _toDisplayString(approver.userName), 1), _createElementVNode("span", _hoisted_108, _toDisplayString(_unref(formatDateTimeText)(approver.actionTime)), 1), approver.action === 'APPROVED' ? (_openBlock(), _createElementBlock("span", _hoisted_109, "通过")) : approver.action === 'REJECTED' ? (_openBlock(), _createElementBlock("span", _hoisted_110, "驳回")) : _createCommentVNode("", true)]), _createElementVNode("p", _hoisted_111, _toDisplayString(approver.remark), 1)], 2)) : _createCommentVNode("", true)], 64);
          }), 128)) : _createCommentVNode("", true)])], 2), index < detail.value.flowNodes.length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_112, [...(_cache[47] || (_cache[47] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 9l-7 7-7-7"
          })], -1)]))])) : _createCommentVNode("", true)]);
        }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_113, " 暂无审批流程信息 "))])]), __props.showCommentEditor ? (_openBlock(), _createElementBlock("div", _hoisted_114, [_cache[48] || (_cache[48] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, "审批意见", -1)), _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => comment.value = $event),
          rows: "3",
          class: "form-textarea",
          placeholder: "请输入审批意见（可选）"
        }, null, 512), [[_vModelText, comment.value]])])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_115, [...(_cache[49] || (_cache[49] = [_createElementVNode("div", {
          class: "text-center py-12 text-slate-400"
        }, [_createElementVNode("svg", {
          class: "w-16 h-16 mx-auto mb-4 text-slate-200",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        })]), _createElementVNode("p", null, "暂无详情数据")], -1)]))])), __props.showActions ? (_openBlock(), _createElementBlock("div", _hoisted_116, [_createElementVNode("button", {
          onClick: handleReject,
          class: "px-5 py-2.5 border border-red-200 text-red-600 rounded-lg hover:bg-red-50"
        }, " 驳回 "), _createElementVNode("button", {
          onClick: handleApprove,
          class: "px-5 py-2.5 bg-green-600 text-white rounded-lg hover:bg-green-700"
        }, " 通过 ")])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["visible"]), isPlanApprovalFlow.value ? (_openBlock(), _createBlock(PlanDetailModal, {
        key: 0,
        visible: showProposalModal.value,
        "plan-id": detail.value?.formData?.planId,
        "plan-data": planDetail.value,
        "onUpdate:visible": _cache[2] || (_cache[2] = $event => showProposalModal.value = $event)
      }, null, 8, ["visible", "plan-id", "plan-data"])) : _createCommentVNode("", true), isCustomerApprovalFlow.value ? (_openBlock(), _createBlock(_unref(CustomerDetailModal), {
        key: 1,
        modelValue: showCustomerModal.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => showCustomerModal.value = $event),
        customer: customerDetail.value
      }, null, 8, ["modelValue", "customer"])) : _createCommentVNode("", true), isOrderApprovalFlow.value ? (_openBlock(), _createBlock(_unref(OrderDetailModal), {
        key: 2,
        visible: showOrderModal.value,
        "onUpdate:visible": _cache[4] || (_cache[4] = $event => showOrderModal.value = $event),
        "order-detail": orderDetail.value,
        "trace-list": orderTraceList.value
      }, null, 8, ["visible", "order-detail", "trace-list"])) : _createCommentVNode("", true), isWealthApprovalFlow.value ? (_openBlock(), _createBlock(_unref(WealthOperationApplyDetailModal), {
        key: 3,
        modelValue: showWealthModal.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => showWealthModal.value = $event),
        "apply-id": wealthApplyId.value,
        "approval-instance-id": wealthApprovalInstanceId.value
      }, null, 8, ["modelValue", "apply-id", "approval-instance-id"])) : _createCommentVNode("", true)]);
    };
  }
};